import { IconButton, TableBody, TableCell, TableRow, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { BaseTable } from "../../../components/table";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { CustomersTablePropsType } from "../../../types/container.type";

export const CustomersTable: React.FC<CustomersTablePropsType> = ({ rows, dropdownRef, selectedCustomerId, handleEllipsisButtonClick, handleActionItemClick }) => {
    const actions = ["View Account Details", "Edit Account Details"];
    const customersTableHeaders = ["Name", "Account Type", "Account Number", "Account Status", "Action"];
    return (
        <BaseTable
            headers={customersTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => (
                    <TableRow key={index}>
                        <TableCell>
                            {`${row?.firstName?.charAt(0).toUpperCase() + row?.firstName?.slice(1)} ${row?.lastName?.charAt(0).toUpperCase() + row?.lastName?.slice(1)}`}
                        </TableCell>
                        <TableCell>{row?.accountType}</TableCell>
                        <TableCell>{row?.accountNumber}</TableCell>
                        <TableCell>{row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1) || "NA"}</TableCell>
                        <TableCell>
                            <IconButton
                                sx={{
                                    borderRadius: "0.5rem",
                                    backgroundColor: "var(--sky-blue-color)",
                                    "&:hover": {
                                        backgroundColor: "var(--sky-blue-color)"
                                    }
                                }}
                                onClick={(e) => handleEllipsisButtonClick(e, row?.id)}
                            >
                                <MoreVertIcon
                                    sx={{
                                        color: "#FFFFFF",
                                        display: "inline-flex",
                                    }}
                                />
                            </IconButton>
                            {(selectedCustomerId && selectedCustomerId === row?.id) && (
                                <List
                                    component={"ul"}
                                    ref={dropdownRef}
                                    className="dropdown-modal"
                                >
                                    {actions.map((action, index) => (
                                        <ListItem
                                            key={index}
                                            onClick={(e) => handleActionItemClick(e, selectedCustomerId, action)}
                                        >
                                            <ListItemButton>
                                                <ListItemText
                                                    primary={action}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    ))}
                                </List>
                            )}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </BaseTable >
    )
}